import type { Live } from "@/types/live";

export const lives: Live[] = [
  {
    id: "1001",
    title: "周末综艺连麦｜一起来吐槽这周的快乐源泉",
    anchorId: "a1",
    categoryKey: "entertainment",
    cover: "https://readdy.ai/api/search-image?query=bright%20lively%20talk%20show%20studio%20stage%20with%20warm%20orange%20lighting%20and%20colorful%20neon%20accents%2C%20modern%20entertainment%20live%20stream%20cover%2C%20clean%20composition&width=800&height=450&seq=mili-live-01&orientation=landscape",
    region: "domestic",
    status: "live",
    viewers: 128400,
    danmaku: 3260,
    startTime: "2026-10-13T20:00:00+08:00",
    description: "每周日晚八点固定开播的欢乐综艺连麦，聊热点、玩互动小游戏，还有不定时抽奖福利。欢迎带上你的快乐一起上麦，规则简单：友善发言、互相尊重、文明连麦。",
    tags: ["综艺连麦", "互动游戏", "每周固定"],
    hot: true,
  },
  {
    id: "1002",
    title: "王者荣耀／星耀冲王者｜高分段打野教学",
    anchorId: "a2",
    categoryKey: "game",
    cover: "https://readdy.ai/api/search-image?query=high%20energy%20esports%20gaming%20setup%20with%20dark%20room%20and%20vivid%20blue%20purple%20accent%20lighting%2C%20competitive%20game%20live%20stream%20cover%2C%20clean%20modern%20composition&width=800&height=450&seq=mili-live-02&orientation=landscape",
    region: "domestic",
    status: "live",
    viewers: 96500,
    danmaku: 2810,
    startTime: "2026-10-13T19:30:00+08:00",
    description: "今晚冲击王者段位，重点讲解打野节奏与反蹲思路，边打边复盘。欢迎提问阵容与出装，弹幕会挑问题集中解答。",
    tags: ["王者荣耀", "打野教学", "冲分"],
    hot: true,
  },
  {
    id: "1003",
    title: "国风现代舞串烧｜今晚跳满一整小时",
    anchorId: "a6",
    categoryKey: "talent",
    cover: "https://readdy.ai/api/search-image?query=elegant%20dance%20performance%20stage%20with%20warm%20golden%20spotlight%20and%20flowing%20silk%20backdrop%2C%20artistic%20talent%20live%20stream%20cover%2C%20clean%20graceful%20composition&width=800&height=450&seq=mili-live-03&orientation=landscape",
    region: "domestic",
    status: "live",
    viewers: 74200,
    danmaku: 1980,
    startTime: "2026-10-13T20:10:00+08:00",
    description: "国风与现代舞穿插串烧，中间会有舞蹈分解教学环节。想学哪个动作可以弹幕留言，跳满一小时不重样。",
    tags: ["舞蹈", "国风", "才艺教学"],
    hot: true,
  },
  {
    id: "1004",
    title: "深夜电台｜聊聊那些说不出口的遗憾",
    anchorId: "a8",
    categoryKey: "chat",
    cover: "https://readdy.ai/api/search-image?query=cozy%20night%20radio%20studio%20with%20warm%20dim%20amber%20lighting%20and%20headphones%20microphone%2C%20calm%20talk%20live%20stream%20cover%2C%20soft%20intimate%20composition&width=800&height=450&seq=mili-live-04&orientation=landscape",
    region: "domestic",
    status: "live",
    viewers: 58300,
    danmaku: 2240,
    startTime: "2026-10-13T22:00:00+08:00",
    description: "凌晨的电台，陪你聊感情、聊选择、聊遗憾。这里没有评判，只有倾听。连线请保持友善，尊重每一位上麦的朋友。",
    tags: ["深夜电台", "情感", "连麦"],
    hot: true,
  },
  {
    id: "1005",
    title: "民谣现场弹唱｜点歌不限量",
    anchorId: "a12",
    categoryKey: "music",
    cover: "https://readdy.ai/api/search-image?query=intimate%20acoustic%20guitar%20live%20performance%20with%20warm%20wood%20tone%20and%20soft%20string%20lights%2C%20music%20live%20stream%20cover%2C%20cozy%20clean%20composition&width=800&height=450&seq=mili-live-05&orientation=landscape",
    region: "domestic",
    status: "live",
    viewers: 41900,
    danmaku: 1560,
    startTime: "2026-10-13T21:00:00+08:00",
    description: "一把吉他，一个夜晚。民谣、流行、原创随你点，点歌请在弹幕打出歌名。今晚还会首唱一首写给夏天的原创。",
    tags: ["民谣", "弹唱", "点歌"],
    hot: true,
  },
  {
    id: "1006",
    title: "城市夜骑漫游｜带你看看凌晨的江边",
    anchorId: "a7",
    categoryKey: "outdoor",
    cover: "https://readdy.ai/api/search-image?query=city%20night%20cycling%20along%20riverside%20with%20glowing%20skyline%20and%20warm%20street%20lights%2C%20outdoor%20live%20stream%20cover%2C%20cinematic%20clean%20composition&width=800&height=450&seq=mili-live-06&orientation=landscape",
    region: "domestic",
    status: "live",
    viewers: 33700,
    danmaku: 890,
    startTime: "2026-10-13T23:00:00+08:00",
    description: "深夜的城市有种安静的美。今晚骑车沿江漫游，边骑边和弹幕聊天，看到好吃的会停下来探店。",
    tags: ["户外", "夜骑", "城市漫游"],
    hot: false,
  },
  {
    id: "1007",
    title: "独立游戏安利会｜这周又挖到宝了",
    anchorId: "a9",
    categoryKey: "game",
    cover: "https://readdy.ai/api/search-image?query=retro%20pixel%20art%20gaming%20arcade%20with%20colorful%20glowing%20screens%20and%20dark%20clean%20background%2C%20indie%20game%20live%20stream%20cover%2C%20playful%20modern%20composition&width=800&height=450&seq=mili-live-07&orientation=landscape",
    region: "international",
    status: "live",
    viewers: 27600,
    danmaku: 760,
    startTime: "2026-10-13T19:00:00+08:00",
    description: "每周三的独立游戏安利会，本周带来三款新发现的像素佳作。也欢迎弹幕投票决定下一个试玩哪款。",
    tags: ["独立游戏", "像素", "安利"],
    hot: false,
  },
  {
    id: "1008",
    title: "治愈系聊天室｜今天也要好好生活呀",
    anchorId: "a10",
    categoryKey: "chat",
    cover: "https://readdy.ai/api/search-image?query=soft%20cozy%20room%20with%20warm%20cream%20tones%20plants%20and%20fairy%20lights%2C%20healing%20chat%20live%20stream%20cover%2C%20gentle%20clean%20composition&width=800&height=450&seq=mili-live-08&orientation=landscape",
    region: "domestic",
    status: "live",
    viewers: 24800,
    danmaku: 1180,
    startTime: "2026-10-13T20:30:00+08:00",
    description: "一个很慢很温柔的聊天室，聊聊今天发生的小事，分享一件让你开心的事。愿这里成为你放松的角落。",
    tags: ["治愈", "聊天", "生活分享"],
    hot: false,
  },
  {
    id: "1009",
    title: "野外露营慢直播｜做饭、看星星、听风",
    anchorId: "a11",
    categoryKey: "outdoor",
    cover: "https://readdy.ai/api/search-image?query=cozy%20camping%20site%20at%20dusk%20with%20warm%20lantern%20light%20tent%20and%20starry%20sky%2C%20outdoor%20live%20stream%20cover%2C%20warm%20calm%20composition&width=800&height=450&seq=mili-live-09&orientation=landscape",
    region: "domestic",
    status: "ended",
    viewers: 18900,
    danmaku: 640,
    startTime: "2026-10-12T18:00:00+08:00",
    description: "在山里露营的第二天，傍晚做一顿柴火饭，天黑后躺着看星星。安静的慢直播，适合当背景音。",
    tags: ["露营", "慢直播", "治愈"],
    hot: false,
  },
  {
    id: "1010",
    title: "女声翻唱夜｜今日主题：影视金曲",
    anchorId: "a5",
    categoryKey: "music",
    cover: "https://readdy.ai/api/search-image?query=warm%20acoustic%20music%20room%20with%20amber%20lighting%20microphone%20and%20soft%20curtain%20backdrop%2C%20female%20singer%20live%20stream%20cover%2C%20clean%20elegant%20composition&width=800&height=450&seq=mili-live-10&orientation=landscape",
    region: "domestic",
    status: "live",
    viewers: 38400,
    danmaku: 1320,
    startTime: "2026-10-13T21:30:00+08:00",
    description: "今晚唱影视金曲，从老歌到新番主题曲都安排上。点歌打歌名，翻唱不限于列表。",
    tags: ["翻唱", "影视金曲", "点歌"],
    hot: false,
  },
  {
    id: "1011",
    title: "战术竞技四排｜随机队友上分挑战",
    anchorId: "a2",
    categoryKey: "game",
    cover: "https://readdy.ai/api/search-image?query=competitive%20battle%20royale%20esports%20setup%20with%20dark%20room%20and%20vivid%20cyan%20accent%20lighting%2C%20gaming%20live%20stream%20cover%2C%20clean%20modern%20composition&width=800&height=450&seq=mili-live-11&orientation=landscape",
    region: "international",
    status: "live",
    viewers: 45200,
    danmaku: 1490,
    startTime: "2026-10-13T22:30:00+08:00",
    description: "随机匹配队友的挑战局，考验临场指挥。目标今晚吃鸡三次，欢迎围观并给出你的战术建议。",
    tags: ["战术竞技", "四排", "挑战"],
    hot: false,
  },
  {
    id: "1012",
    title: "手工黏土小课堂｜捏一只专属萌宠",
    anchorId: "a6",
    categoryKey: "talent",
    cover: "https://readdy.ai/api/search-image?query=colorful%20clay%20craft%20table%20with%20pastel%20tools%20and%20warm%20soft%20lighting%2C%20handcraft%20live%20stream%20cover%2C%20clean%20cheerful%20composition&width=800&height=450&seq=mili-live-12&orientation=landscape",
    region: "domestic",
    status: "live",
    viewers: 21300,
    danmaku: 720,
    startTime: "2026-10-13T20:20:00+08:00",
    description: "手把手教你用黏土捏一只萌宠，材料简单，新手也能跟上。做完的成品会抽取一位观众送出。",
    tags: ["手工", "黏土", "教学"],
    hot: false,
  },
  {
    id: "1013",
    title: "脱口秀开放麦｜吐槽我的社畜日常",
    anchorId: "a3",
    categoryKey: "entertainment",
    cover: "https://readdy.ai/api/search-image?query=standup%20comedy%20open%20mic%20stage%20with%20warm%20spotlight%20and%20red%20curtain%2C%20comedy%20live%20stream%20cover%2C%20clean%20lively%20composition&width=800&height=450&seq=mili-live-13&orientation=landscape",
    region: "domestic",
    status: "live",
    viewers: 31200,
    danmaku: 1040,
    startTime: "2026-10-13T19:45:00+08:00",
    description: "今晚开放麦，主题是社畜日常。欢迎在弹幕投稿你的工作段子，被选中的会现场讲出来哦。",
    tags: ["脱口秀", "开放麦", "搞笑"],
    hot: false,
  },
  {
    id: "1014",
    title: "游戏历史课｜那些改变行业的神作",
    anchorId: "a4",
    categoryKey: "game",
    cover: "https://readdy.ai/api/search-image?query=retro%20game%20collection%20shelf%20with%20warm%20library%20lighting%20and%20nostalgic%20atmosphere%2C%20game%20culture%20talk%20live%20stream%20cover%2C%20warm%20clean%20composition&width=800&height=450&seq=mili-live-14&orientation=landscape",
    region: "international",
    status: "ended",
    viewers: 16700,
    danmaku: 520,
    startTime: "2026-10-12T20:00:00+08:00",
    description: "从红白机讲到现代 3A，聊聊那些真正改变了行业的游戏。这期讲开放世界的起源与演变。",
    tags: ["游戏历史", "解说", "科普"],
    hot: false,
  },
  {
    id: "1015",
    title: "美食探店｜藏在巷子里的宝藏小馆",
    anchorId: "a7",
    categoryKey: "outdoor",
    cover: "https://readdy.ai/api/search-image?query=cozy%20street%20food%20alley%20with%20warm%20lantern%20lighting%20and%20steaming%20dishes%2C%20food%20tour%20live%20stream%20cover%2C%20appetizing%20clean%20composition&width=800&height=450&seq=mili-live-15&orientation=landscape",
    region: "domestic",
    status: "live",
    viewers: 29400,
    danmaku: 980,
    startTime: "2026-10-13T18:30:00+08:00",
    description: "跟着地图钻进巷子，寻找本地人私藏的宝藏小馆。今晚目标三家，边吃边给大家报菜名。",
    tags: ["美食", "探店", "城市"],
    hot: false,
  },
  {
    id: "1016",
    title: "原创音乐分享会｜聊聊写歌这件事",
    anchorId: "a12",
    categoryKey: "music",
    cover: "https://readdy.ai/api/search-image?query=home%20music%20studio%20with%20warm%20wood%20tones%20guitar%20and%20soft%20ambient%20lighting%2C%20original%20music%20live%20stream%20cover%2C%20cozy%20clean%20composition&width=800&height=450&seq=mili-live-16&orientation=landscape",
    region: "international",
    status: "live",
    viewers: 19800,
    danmaku: 610,
    startTime: "2026-10-13T22:10:00+08:00",
    description: "分享几首自己写的歌，聊聊背后的创作故事和灵感来源，也欢迎弹幕点题让我即兴哼一段。",
    tags: ["原创", "音乐分享", "创作"],
    hot: false,
  },
  {
    id: "1017",
    title: "早间元气直播｜跟着我一起做拉伸",
    anchorId: "a10",
    categoryKey: "talent",
    cover: "https://readdy.ai/api/search-image?query=bright%20airy%20morning%20yoga%20space%20with%20soft%20daylight%20and%20plants%2C%20wellness%20live%20stream%20cover%2C%20clean%20fresh%20composition&width=800&height=450&seq=mili-live-17&orientation=landscape",
    region: "domestic",
    status: "live",
    viewers: 15600,
    danmaku: 430,
    startTime: "2026-10-13T07:30:00+08:00",
    description: "每天早上的元气拉伸课，十分钟唤醒身体。适合久坐党，动作简单，边做边聊今天的小计划。",
    tags: ["早间", "拉伸", "健康"],
    hot: false,
  },
  {
    id: "1018",
    title: "恐怖游戏深夜档｜这次一定要通关",
    anchorId: "a9",
    categoryKey: "game",
    cover: "https://readdy.ai/api/search-image?query=dark%20moody%20horror%20gaming%20room%20with%20eerie%20green%20accent%20lighting%20and%20fog%2C%20horror%20game%20live%20stream%20cover%2C%20cinematic%20composition&width=800&height=450&seq=mili-live-18&orientation=landscape",
    region: "international",
    status: "live",
    viewers: 37800,
    danmaku: 1620,
    startTime: "2026-10-13T23:30:00+08:00",
    description: "胆子小但嘴硬系列。今晚挑战一款新出的恐怖游戏，弹幕可以点惊吓指令，但我可能真的会被吓到。",
    tags: ["恐怖游戏", "深夜", "通关"],
    hot: false,
  },
  {
    id: "1019",
    title: "连麦盲盒｜随机连线聊聊人生",
    anchorId: "a8",
    categoryKey: "chat",
    cover: "https://readdy.ai/api/search-image?query=warm%20podcast%20studio%20with%20soft%20amber%20lighting%20and%20microphones%2C%20talk%20show%20live%20stream%20cover%2C%20clean%20intimate%20composition&width=800&height=450&seq=mili-live-19&orientation=landscape",
    region: "domestic",
    status: "live",
    viewers: 26700,
    danmaku: 890,
    startTime: "2026-10-13T21:15:00+08:00",
    description: "随机连麦的盲盒环节，谁先举手谁先上麦，聊聊各自的故事。尊重与倾听是这里唯一的规则。",
    tags: ["连麦", "盲盒", "对话"],
    hot: false,
  },
  {
    id: "1020",
    title: "游戏速通挑战｜今晚打破自己的记录",
    anchorId: "a4",
    categoryKey: "game",
    cover: "https://readdy.ai/api/search-image?query=speedrun%20gaming%20setup%20with%20timer%20on%20screen%20and%20cool%20blue%20accent%20lighting%2C%20speedrun%20live%20stream%20cover%2C%20clean%20focused%20composition&width=800&height=450&seq=mili-live-20&orientation=landscape",
    region: "international",
    status: "live",
    viewers: 22900,
    danmaku: 700,
    startTime: "2026-10-13T19:15:00+08:00",
    description: "今晚刷自己的速通记录，目标是刷新上周的成绩。会把关键路线与操作细节实时讲出来。",
    tags: ["速通", "挑战", "技术"],
    hot: false,
  },
  {
    id: "1021",
    title: "甜品制作直播｜舒芙蕾新手友好版",
    anchorId: "a3",
    categoryKey: "talent",
    cover: "https://readdy.ai/api/search-image?query=cozy%20kitchen%20dessert%20making%20with%20warm%20lighting%20and%20cream%20pastel%20tones%2C%20cooking%20live%20stream%20cover%2C%20clean%20appetizing%20composition&width=800&height=450&seq=mili-live-21&orientation=landscape",
    region: "domestic",
    status: "ended",
    viewers: 14300,
    danmaku: 380,
    startTime: "2026-10-11T15:00:00+08:00",
    description: "教你做新手也不翻车的舒芙蕾，从打发蛋白到出锅每一步都讲清楚。做失败的常见原因也一并解答。",
    tags: ["甜品", "烘焙", "教学"],
    hot: false,
  },
  {
    id: "1022",
    title: "公路旅行日记｜一路向西的第三天",
    anchorId: "a11",
    categoryKey: "outdoor",
    cover: "https://readdy.ai/api/search-image?query=road%20trip%20through%20desert%20highway%20at%20golden%20hour%20with%20warm%20sunlight%2C%20travel%20live%20stream%20cover%2C%20cinematic%20clean%20composition&width=800&height=450&seq=mili-live-22&orientation=landscape",
    region: "domestic",
    status: "live",
    viewers: 20500,
    danmaku: 560,
    startTime: "2026-10-13T16:00:00+08:00",
    description: "公路旅行的第三天，今天要翻过一座山口到达湖边营地。沿途风景一流，会不定期停车给大家看风景。",
    tags: ["旅行", "公路", "风景"],
    hot: false,
  },
  {
    id: "1023",
    title: "深夜钢琴｜安静地弹给你们听",
    anchorId: "a5",
    categoryKey: "music",
    cover: "https://readdy.ai/api/search-image?query=grand%20piano%20in%20dim%20elegant%20room%20with%20soft%20warm%20spotlight%2C%20piano%20performance%20live%20stream%20cover%2C%20refined%20clean%20composition&width=800&height=450&seq=mili-live-23&orientation=landscape",
    region: "international",
    status: "live",
    viewers: 17400,
    danmaku: 520,
    startTime: "2026-10-13T23:15:00+08:00",
    description: "关掉大部分灯光，只留一盏琴灯。今晚弹一些安静的曲子，适合睡前听，也适合安静地发呆。",
    tags: ["钢琴", "纯音乐", "助眠"],
    hot: false,
  },
  {
    id: "1024",
    title: "新版本抢先看｜第一手实机演示",
    anchorId: "a2",
    categoryKey: "game",
    cover: "https://readdy.ai/api/search-image?query=futuristic%20gaming%20studio%20with%20vivid%20orange%20and%20teal%20accent%20lighting%2C%20game%20preview%20live%20stream%20cover%2C%20clean%20modern%20composition&width=800&height=450&seq=mili-live-24&orientation=landscape",
    region: "international",
    status: "live",
    viewers: 52100,
    danmaku: 1870,
    startTime: "2026-10-13T20:45:00+08:00",
    description: "新版本今日上线，第一时间带来实机演示与改动解析。重点讲新角色强度平衡与上分思路。",
    tags: ["新版本", "实机演示", "解析"],
    hot: true,
  },
];